import type { FC } from "react";
import React, { useMemo } from "react";

import { HEADER_SCHEVRON_TEST_ID } from "./utils/createTestId";
import { extractProps, getChildrenRecord } from "../../../utils/react";
import { CoreHeader } from "../general/CoreHeader/CoreHeader";

import type { HeaderSchevronProps } from "./types";

export const HEADER_SCHEVRON_DISPLAY_NAME = "HeaderSchevron";

/**
 * Компонент для отображения и разметки заголовков, основан на CoreHeader.
 *
 * Умеет отображать заголовки нескольких уровней, в качестве rightAddon предустановлен buttonCircle с иконкой-стрелкой "Перейти".
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=7340-437402&m=dev" target="_blank">Спека</a>
 * @constructor
 */
export const HeaderSchevron: FC<HeaderSchevronProps> = (props) => {
    const {
        customVarsStyles,
        currentProps: {
            view = "primary",
            children,
            "data-tsid": tsid = HEADER_SCHEVRON_TEST_ID,
            ...restProps
        },
    } = useMemo(() => extractProps(props, ["customVarsStyles"]), [props]);

    const content = useMemo(
        () =>
            getChildrenRecord(
                children,
                HEADER_SCHEVRON_DISPLAY_NAME,
                {
                    Title: {
                        props: { view },
                        required: true,
                    },
                    CounterInline: {
                        props: { view },
                    },
                    Subtitle: {
                        props: { view },
                    },
                    Unknown: {
                        skipElement: true,
                    },
                },
                { isArrayResult: true },
            ),
        [children, view],
    );

    return (
        <CoreHeader
            {...restProps}
            customVarsStyles={customVarsStyles}
            data-tsid={tsid}
            data-uikit={HEADER_SCHEVRON_DISPLAY_NAME}
            view={view}
            state="enabled"
            prefix="HeaderSchevron"
        >
            {content}
        </CoreHeader>
    );
};

HeaderSchevron.displayName = HEADER_SCHEVRON_DISPLAY_NAME;

export default HeaderSchevron;
